<template>
  <div class="chat-faq-box">
    <div class="title">
      {{ $t("userCenter.关于") }}{{ title }}{{ $t("userCenter.您可能是想问") }}
    </div>
    <div class="list">
      <div
        v-for="item in calcData"
        :key="item.id"
        class="item"
        @click="handleFaq(item)"
      >
        <span class="label">{{ item.title }}</span>
        <van-icon class="arrow" name="arrow" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { getUrlQuery } from "@/utils/util";

export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
  },
  computed: {
    // 只取前5个
    calcData() {
      return this.data.slice(0, 5);
    },
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions(["checkLogin"]),
    handleFaq(item) {
      if (item.form_id) {
        this.checkLogin()
          .then(() => {
            let query = getUrlQuery(item.form_url);
            let pathDict = [
              "/change-phone",
              "/ban-query",
              "/props-flow",
              "/special-props-flow",
              "/account-info",
            ];
            for (let i = 0; i < pathDict.length; i++) {
              if (item.form_url.includes(pathDict[i])) {
                this.$router.push({
                  path: pathDict[i],
                  query,
                });
                return;
              }
            }
            if (!item.token && !item.form_id) {
              window.open(item.form_url);
            } else {
              this.$router.push({
                name: "Report",
                query: {
                  formToken: item.token,
                  id: item.form_id,
                  title: item.title,
                },
              });
            }
          })
          .catch((err) => {
            this.$eventBus.$emit("showLogin");
          });
      } else {
        this.$emit("faq", item);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.chat-faq-box {
  width: calc(100% - 50px);
  margin: 7.5px 0;
  border-radius: 15px;
  border-top-left-radius: 0 15px;
  background-color: #fff;
  .title {
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0 10px;
    box-sizing: border-box;
    color: #333;
    font-size: 14px;
    font-weight: 500;
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  }
  .list {
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      padding: 0 10px;
      box-sizing: border-box;
      border-bottom: 1px solid rgba(0, 0, 0, 0.04);
      color: #666;
      font-size: 14px;
      &:last-child {
        border-bottom: none;
      }
      .label {
        flex: 1;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .arrow {
        flex: 0 0 auto;
      }
    }
  }
}
</style>
